// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/Users/knewtone/OneDrive/knewtone.com/projects/WorkSpace/customers/g-letitan.media/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("/Users/knewtone/OneDrive/knewtone.com/projects/WorkSpace/customers/g-letitan.media/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/knewtone/OneDrive/knewtone.com/projects/WorkSpace/customers/g-letitan.media/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/knewtone/OneDrive/knewtone.com/projects/WorkSpace/customers/g-letitan.media/.cache/data.json")

